function initPopup(width) {
    function addClass(element, className) {
      if (element.classList) {
        element.classList.add(className);
      } else {
        element.className += ' ' + className;
      }
    }
  
    function removeClass(element, className) {
      if (element.classList) {
        element.classList.remove(className);
      } else {
        element.className = element.className.replace(
          new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'),
          ' '
        );
      }
    }
  
    // Open
    document.querySelectorAll('.js-popup-open').forEach(function (element) {
      element.addEventListener('click', function () {
        var popupId = this.getAttribute('data-trigger');
        var popup = document.querySelector('[data-popup="' + popupId + '"]');
        var mobile = this.getAttribute('data-mobile');
  
        if (width > 768) {
          if (popupId !== 'sort-by') {
            if (!mobile && popupId !== 'menu') {
              popup.style.display = 'block';
              addClass(document.body, 'overflow');
  
              if (popup.classList.contains('popup-blure')) {
                addClass(document.querySelector('.main'), 'blur');
                addClass(document.querySelector('.header'), 'blur');
                removeClass(document.querySelector('.footer'), 'blur');
              }
            } else {
              addClass(popup, 'active');
              addClass(document.body, 'overflow');
            }
          } else {
            removeClass(popup, 'active');
            removeClass(document.body, 'overflow');
          }
        } else {
          addClass(popup, 'active');
          addClass(document.body, 'overflow');
        }
      });
    });
  
    // Close
    document.querySelectorAll('.js-popup-close').forEach(function (element) {
        element.addEventListener('click', function (e) {
        var target = e.target;

        if (width > 768) {
            if (
            target &&
            target.closest('[data-popup="size-guide"]')
            ) {
            var popup = this.closest('.popup');
            popup.style.display = 'none';

            if (document.querySelector('.main').classList.contains('blur')) {
                removeClass(document.querySelector('.main'), 'blur');
                removeClass(document.querySelector('.header'), 'blur');
                removeClass(document.querySelector('.footer'), 'blur');
            }
            } else {
            removeClass(this.closest('.popup'), 'active');
            }
        } else {
            removeClass(this.closest('.popup'), 'active');
        }

        removeClass(document.body, 'overflow');
        });
    });
}
  
initPopup(window.innerWidth);

let firstListElement = document.querySelector('.list');

if (firstListElement) {
  firstListElement.style.display = 'block';
}

setTimeout(() => {
  let drop = document.querySelector('.menu__title--list');
    drop.classList.add('active');
}, 500);

$('.js-item-btn').click(function (e) {
    if (!e.target.closest('.footer')) {
      if (e.target.closest('.menu--filters')) {
        if ($(window).width() > 768) {
          if ($(this).hasClass('active')) {
            $(this).removeClass('active').next().slideToggle();
            return;
          } else {
            $(this).closest('.menu--filters').find('.js-item-btn.active').removeClass('active').next().slideToggle();
            $(this).closest('.js-catalog-filters').find('.filters-btn.active').removeClass('active').next().find('.filters__wrap').css('max-height', 0);
            $(this).next().slideToggle();
            $(this).addClass('active');
            return;
          }
        }
      }

      $(this).nextUntil("li.menu__item").slideToggle();
      $(this).toggleClass('active');
    }
});

$('.js-search-opener').click(function () {
  $(this).next().addClass('active');
  $('body').addClass('search-opened');
});
$('.js-search-close').click(function () {
  $(this).closest('.js-search-field').removeClass('active');
});